<script>
import _ from 'lodash'
import service from '@/request/base'
import ImageService from '@/request/file/image'
import PotentialService from '@/request/patient/potential'
import EberFiles from '@/components/EberFiles'
import VuePhotoSwipe from '@/components/VuePhotoSwipe'
export default {
  name: 'SymptomImageList',
  components: {
    VuePhotoSwipe,
    EberFiles
  },
  props: {
    sourceId: {
      type: Number,
      default: 0
    },
    mark: {
      type: String,
      default: '医步'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    enableDrag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      files: [],
      vpsoptions: {
        index: 0,
        thumbnailParentClass: 'eber-symptom-files-' + this._uid + '-' + this.sourceId,
        srcname: 'image',
        wname: 'width',
        hname: 'height',
        tname: 'remark',
        shareEl: true,
        shareButtons: [{
          id: 'remark',
          label: '备注',
          url: 'button'
        }, {
          id: 'download',
          label: '下载',
          url: '{{raw_image_url}}',
          download: true
        }]
      },
      showPhotoSwipe: false
    }
  },
  created () {
    this.listImage()
  },
  computed: {},
  mounted () {},
  watch: {
    sourceId (newVal, oldVal) {
      if (oldVal) {
        this.listImage()
      } else if (newVal) {
        this.saveImages().then(() => {
          this.listImage()
        }).catch(error => {
          this.$message.error(error)
        })
      }
    },
    classify () {
      if (!this.sourceId) {
        return
      }
      this.listImage()
    }
  },
  methods: {
    listImage () {
      this.files = []
      if (!this.sourceId) {
        return
      }
      PotentialService.listImage({
        symptom: this.sourceId
      }).then(res => {
        let imgs = res.result || []
        if (!_.isEmpty(imgs)) {
          _.forEach(imgs, img => {
            img.thumbnail = service.url(img.thumbnail)
            img.image = service.url(img.image)
          })
        }
        this.files = _.clone(imgs)
      })
    },
    handleDeleteImage (options) {
      if (!this.sourceId) {
        return
      }
      if (!options || !options.id) {
        this.$message.error('图片信息有误，请刷新页面重试删除')
        return
      }
      let self = this
      self.$confirm('确认删除这张图片吗?', '提示', {type: 'warning'}).then(() => {
        PotentialService.deleteImage({
          id: options.id
        }).then(() => {
          let index = _.findIndex(self.files, {'id': options.id})
          if (index >= 0) {
            self.files.splice(index, 1)
          }
          self.$emit('remove', options)
        }, err => {
          self.$message.error(err)
        }).catch(error => {
          self.$message.error(error || '删除图片失败')
        })
      }, () => {
        self.$message({
          message: '取消操作!',
          type: 'info'
        })
      })
    },
    handleUploadImage (options) {
      let self = this
      return new Promise((resolve, reject) => {
        ImageService.uploadImage(options.file, self.mark, null, options.onProgress).then(uimg => {
          uimg = uimg.result
          if (!uimg) {
            reject(new Error('上传图片失败'))
          } else {
            resolve(uimg)
          }
        }).catch(error => {
          reject(error || new Error('上传图片失败'))
        })
      })
    },
    handleUploadImageSuccess (data) {
      let img = {
        symptom: this.sourceId,
        thumbnail: data.small,
        type: 0,
        orderNum: this.files.length + 1,
        image: data.superSrc,
        width: data.width,
        height: data.height,
        tempid: data.id
      }
      let temp = _.cloneDeep(img)
      temp.thumbnail = service.url(temp.thumbnail)
      temp.image = service.url(temp.image)
      this.files.push(temp)
      this.files = _.sortBy(this.files, ['orderNum'])
      if (!this.sourceId) {
        return
      }
      PotentialService.saveImage(img).then(img => {
        img = img.result
        img.thumbnail = service.url(img.thumbnail)
        img.image = service.url(img.image)
        let index = _.findIndex(this.files, {'tempid': data.id})
        if (index < 0) {
          return
        }
        this.$set(this.files, index, _.clone(img))
      }).catch(error => {
        this.$message.error(error || '添加图片失败')
      })
    },
    handleChangeFileStatus (file, fileList) {
      if (file.status === 'success') {
        _.remove(fileList, function (item) {
          return item.uid === file.uid
        })
      }
    },
    clearImages () {
      if (_.isEmpty(this.files)) {
        return
      }
      for (let i = 0; i < this.files.length;) {
        if (this.files[i]['symptom'] && this.files[i]['symptom'] !== this.sourceId) {
          this.files.splice(i, 1)
          continue
        }
        if (this.sourceId && this.sourceId !== this.files[i]['symptom']) {
          this.files.splice(i, 1)
          continue
        }
        i++
      }
    },
    saveImages () {
      let self = this
      return new Promise((resolve, reject) => {
        if (!self.sourceId) {
          reject(new Error('图片列表的主体为空'))
          return
        }
        let idkey = 'symptom'
        let ps = []
        _.forEach(self.files, img => {
          if (!img.id || !img[idkey]) {
            let temp = _.cloneDeep(img)
            temp.classify = self.classify
            temp[idkey] = self.sourceId
            temp.thumbnail = img.thumbnail.replace(service.BasePath(), '')
            temp.image = img.image.replace(service.BasePath(), '')
            ps.push(PotentialService.saveImage(temp))
          }
        })
        Promise.all(ps).then(() => {
          resolve()
          this.$emit('saveImagesDone')
        }).catch(error => {
          reject(error || new Error('保存图片失败'))
          this.$emit('saveImagesFail', error)
        })
      })
    },
    handleShareLinkClick (e, target) {
      console.log(e)
      console.log(target)
    },
    handlePreview (file) {
      let index = _.findIndex(this.files, {'id': file.id})
      this.vpsoptions.index = index
      this.showPhotoSwipe = true
    },
    handleSortFiles (file, newIndex, oldIndex) {
      if (!this.sourceId) {
        return
      }
      if (newIndex === oldIndex) {
        return
      }
      let i = 1
      _.forEach(this.files, file => {
        if (file.orderNum !== i) {
          file = _.cloneDeep(file)
          file.orderNum = i
          file.thumbnail = file.thumbnail.replace(service.BasePath(), '')
          file.image = file.image.replace(service.BasePath(), '')
          file['_index'] = i - 1
          PotentialService.saveImage(file).then(img => {
            img = img.result
            img.thumbnail = service.url(img.thumbnail)
            img.image = service.url(img.image)
            this.$set(this.files, file['_index'], _.clone(img))
          })
        }
        i++
      })
    }
  }
}
</script>

<template>
  <div class="eber-file-wrap clear">
    <eber-files
      v-if="files.length > 0"
      v-model="files"
      :custom-class="vpsoptions.thumbnailParentClass"
      :handlePreview="handlePreview"
      :disabled="disabled || !sourceId"
      :enable-drag="enableDrag && !!sourceId"
      @remove="handleDeleteImage"
      @sort="handleSortFiles"
    ></eber-files>
    <p v-if="files.length <= 0 && disabled" class="none-image">暂无图片</p>
    <el-upload
      v-if="!disabled && !enableDrag"
      action="upload"
      accept="image/*"
      multiple
      :http-request="handleUploadImage"
      :on-success="handleUploadImageSuccess"
      :on-change="handleChangeFileStatus"
      list-type="picture-card">
      <i class="el-icon-plus"></i>
    </el-upload>
    <eber-photo-viewer
      v-if="showPhotoSwipe"
      :images="files"
      :show-index="vpsoptions.index"
      @close="showPhotoSwipe=false">
    </eber-photo-viewer>
<!--    <vue-photo-swipe :options="vpsoptions" :images="files" :thumbnailElementSelection="'.' + vpsoptions.thumbnailParentClass + ' .eber-file-list__item'" :show="showPhotoSwipe" @close="showPhotoSwipe=false" @shareLinkClick="handleShareLinkClick"></vue-photo-swipe>-->
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.eber-file-wrap {
}
.none-image {
  text-align: center;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  line-height: 148px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
</style>
